/**
 * @file STARS作成
 */
'use strict';

/**
 * @classname InputOpenStatus
 * @classdesc STARS作成
 */
export default class InputOpenStatus {
	/**
	 * @constructor
	 * @param {jQuery} $e - 該当する jQuery オブジェクト
	 */
	constructor($e) {
		console.log('InputOpenStatus.constructor');
		this._$e = $e;
		this._openValue =$e.attr('data-open-value')
		this._$radioButtons = $e.find('input[type="radio"]');

		//公開開始のラジオボタン（即時公開、公開日を指定する）
		this._$open_timing_select = $('.open_timing_select')

		//公開開始日
		this._$open_start_date = $('.open_start_date').find('input')

		//公開終了日
		this._$open_end_date = $('.open_end_date').find('input')

		this._$radioButtons.on('change', () => this.onChange());

		this._$open_timing_select.find('input').on('change', () => this.onTimingChange());
		this.onChange()
	};


	/**
	 * 公開・非公開の切り替え
	 *
	 * @memberof InputOpenStatus
	 * @return {undefined}
	 */
	 onChange() {
		console.log('InputOpenStatus.onChange');

		const val = this._$e.find('input[type="radio"]:checked').val();

		// 公開時
		if(val === this._openValue ){
			this._$open_timing_select.removeClass('hide')
			this.onTimingChange()
			this._$open_end_date.removeClass('-disabled-');

		} else {
			this._$open_timing_select.addClass('hide')
			//非公開時は公開開始日は変更不可
			this._$open_start_date.addClass('-disabled-');
			this._$open_end_date.addClass('-disabled-');

		}

	};


	/**
	 * 今日の日付を取得
	 *
	 * @memberof InputOpenStatus
	 * @return formattedDate
	 */
	 getToday() {
		console.log('InputOpenStatus.getToday');

		const today = new Date();

		// 年月日を取得
		const year = today.getFullYear();
		const month = String(today.getMonth() + 1).padStart(2, '0');  // 月は0から始まるため+1する
		const day = String(today.getDate()).padStart(2, '0');
		
		// YYYY-MM-DDの形式でフォーマット
		const formattedDate = year + '/' + month + '/' + day;
		
		console.log('formattedDate::' + formattedDate)
		return formattedDate
	}

	/**
	 * 公開日を指定する、即日公開の切り替え
	 *
	 * @memberof InputOpenStatus
	 * @return {undefined}
	 */

	onTimingChange(){
		console.log('InputOpenStatus.onTimingChange');

		const isTodayOpen = this._$open_timing_select.find('input:checked').val() === '2';

		//即時公開 (value=2)
		if (isTodayOpen) {
			this._$open_start_date.val(this.getToday())
			this._$open_start_date.addClass('-disabled-');


		//公開日指定 (value=1)
		}else {
			this._$open_start_date.removeClass('-disabled-');
			this._$open_start_date.attr('data-datepicker', true)
		}
	}

}
